export const SET_PINS_ERROR = 'SET_PINS_ERROR'
export const CLEAR_PINS_ERROR = 'CLEAR_PINS_ERROR'
export const MAP_PINS_RECEIVED = 'PINS_RECEIVED'
export const UPDATE_SHOWN_PINS = 'UPDATE_SHOWN_PINS'
export const UPDATE_GIVEN_STAR_VALUE = 'UPDATE_GIVEN_STAR_VALUE'
